import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as actionCreators from "../../modules/actions";
import { minPlanLimitCheck } from "../../pages/trivia/data";

function TrivvyImmediateRewardToast({
  user,
  handleGlobalRewardModal,
  noPlanCustomMessage,
  trivvyIds,
  history
}) {
  // const planValid = user && user.profile && user.profile.organizationId ? minPlanLimitCheck(
  //   user.profile.organizationId.trivvyPlanType,
  //   "001"
  // ):false;

  const planValid = true

  console.log(trivvyIds, Array.isArray(trivvyIds) , trivvyIds.length > 1)

  const isSingular = trivvyIds && Array.isArray(trivvyIds) && trivvyIds.length > 1 ? false :true;

  return (
    <div>
      {planValid ? (
        <div>
          <div>
           {isSingular?"Trivvy is":"Trivvys are"} successfully generated! 
            <br />
            {/* Click <b onClick={()=> {
                if(trivvyIds && trivvyIds[0] && history){
                  history.push(`/home/trivia/${user.profile.organizationId._id}/edit/${trivvyIds[0]}/edit`)
                }
            } }>here</b> or in table to view it. */}
          </div>
        </div>
      ) : (
        <div>{noPlanCustomMessage || <span> {isSingular?"Trivvy is":"Trivvys are"} successfully generated! </span>}</div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleGlobalRewardModal: (data) =>
      dispatch(actionCreators.handleGlobalRewardModal(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrivvyImmediateRewardToast);
